import React from "react";
import { NavLink } from "react-router-dom";

const BookDemoCard = () => {
  return (
    <section className="book-demo-section" aria-labelledby="demo-title">
      <div className="book-demo-container">
        <div className="book-demo-content" role="region" aria-label="Strategy session details">
          {/* Left Content */}
          <div className="book-demo-text">
            <header>
              <h2 id="demo-title" className="demo-heading">
                Book Your Complimentary Strategy Session
              </h2>
              <p className="demo-subheading">
                Let our experts walk you through a tailored solution for your business growth.
              </p>
            </header>

            <ul className="benefits-list">
              <li className="benefit-item">
                <span className="benefit-icon" aria-hidden>🚀</span>
                <span>30-minute personalized strategy call</span>
              </li>
              <li className="benefit-item">
                <span className="benefit-icon" aria-hidden>🎯</span>
                <span>Live walkthrough of solutions that fit your needs</span>
              </li>
              <li className="benefit-item">
                <span className="benefit-icon" aria-hidden>💡</span>
                <span>Expert insights with zero obligation</span>
              </li>
            </ul>

            <p className="demo-cta">
              Secure your spot today and discover the fastest path to your next big win.
            </p>

           <NavLink to="/contact#contactusform">
  <button 
    type="button" 
    className="demo-button" 
    aria-label="Book a demo strategy session"
  >
    Book Demo
    <svg className="arrow-icon" viewBox="0 0 24 24" aria-hidden="true">
      <path d="M5 12h14M12 5l7 7-7 7" />
    </svg>
  </button>
</NavLink>
          </div>

          {/* Right Content - Customer Focus */}
          <aside className="book-demo-highlights" aria-label="Customer highlights">
            <div className="highlight">
              <h3 className="highlight-title">Why Customers Choose Us</h3>
              <ul className="highlight-list">
                <li>✔️ Proven track record of accelerating growth</li>
                <li>✔️ Trusted by startups & enterprises alike</li>
                <li>✔️ Dedicated experts focused on your success</li>
              </ul>
              <div className="highlight-metrics" aria-hidden>
                
                <span className="metric-chip"><strong>2k+</strong> Sessions booked</span>
                
              </div>
              <p className="no-hard-sell">No hard sell — just insights tailored to you.</p>
            </div>
          </aside>
        </div>
      </div>

      <style jsx>{`
        .book-demo-section {
          font-family: "Inter", system-ui, -apple-system, Segoe UI, Roboto, sans-serif;
          background: linear-gradient(135deg, #01203aff 0%, #1e1b4b 50%, #1e1b4b 100%);
          padding: 1.5rem 1rem;
          display: flex;
          justify-content: center;
        }
        .book-demo-container {
          width: 100%;
          max-width: 1000px;
        }
        .book-demo-content {
          display: flex;
          background: #ffffff;
          border-radius: 12px;
          box-shadow: 0 8px 22px rgba(0, 0, 0, 0.15);
          overflow: hidden;
          transition: box-shadow 0.3s ease, transform 0.3s ease;
        }
        .book-demo-content:hover {
          transform: translateY(-2px);
          box-shadow: 0 12px 28px rgba(0, 0, 0, 0.2);
        }

        .book-demo-text {
          flex: 1.3;
          padding: 1.25rem;
        }
        .demo-heading {
          font-size: 1.65rem;
          font-weight: 700;
          color: #111827;
          margin-bottom: 0.6rem;
        }
        .demo-subheading {
          font-size: 1rem;
          color: #000000ff;
          margin-bottom: 1rem;
        }
        .benefits-list {
          margin: 0.5rem 0 1rem 0;
          padding: 0;
          list-style: none;
        }
        .benefit-item {
          display: flex;
          align-items: center;
          margin-bottom: 0.5rem;
          font-size: 0.95rem;
          color: #374151;
          transition: transform 0.25s ease, color 0.25s ease;
        }
        .benefit-item:hover {
          transform: translateX(4px);
          color: #01caf0;
        }
        .benefit-icon {
          font-size: 1.2rem;
          margin-right: 0.6rem;
        }
        .demo-cta {
          font-size: 0.95rem;
          color: #374151;
          margin: 0.8rem 0 1rem 0;
        }
        .demo-button {
          display: inline-flex;
          align-items: center;
          background: linear-gradient(90deg, #2563eb, #7c3aed);
          color: #ffffff;
          border: none;
          border-radius: 8px;
          padding: 0.65rem 1.2rem;
          font-size: 0.95rem;
          font-weight: 600;
          cursor: pointer;
          box-shadow: 0 6px 16px rgba(124, 58, 237, 0.25);
          transition: transform 0.25s ease, box-shadow 0.25s ease;
        }
        .demo-button:hover {
          transform: translateY(-2px);
          box-shadow: 0 10px 20px rgba(37, 99, 235, 0.35);
        }
        .arrow-icon {
          width: 18px;
          height: 18px;
          margin-left: 0.4rem;
          stroke: currentColor;
          stroke-width: 2;
          stroke-linecap: round;
          stroke-linejoin: round;
          fill: none;
          transition: transform 0.25s ease;
        }
        .demo-button:hover .arrow-icon {
          transform: translateX(4px);
        }

        /* Right Content with better single-tone gradient */
        .book-demo-highlights {
          flex: 1;
          background: linear-gradient(135deg, #00e3d1 0%, #00e3d1 100%);
          color: #ffffff;
          display: flex;
          align-items: center;
          justify-content: center;
          padding: 1.25rem;
           font-family: 'Roboto', sans-serif;
           font-weight: 700;
        }
        .highlight {
          text-align: left;
          max-width: 340px;
        }
        .highlight-title {
          font-size: 1.50rem;
          font-weight: 700;
          margin-bottom: 0.6rem;
          color: #020202ff;
          font-family: 'Roboto', sans-serif;
        }
        .highlight-list {
          margin: 0 0 0.8rem 0;
          padding: 0;
          list-style: none;
        }
        .highlight-list li {
          font-size: 1rem;
          margin-bottom: 0.5rem;
          color: #000000ff;
        }
        .highlight-metrics {
          display: flex;
          flex-wrap: wrap;
          gap: 0.5rem;
          margin-bottom: 0.6rem;
        }
        .metric-chip {
          font-size: 0.8rem;
          padding: 0.3rem 0.55rem;
          border-radius: 999px;
          background: rgba(255, 255, 255, 0.2);
          color: #000000ff;
          backdrop-filter: blur(4px);
        }
        .no-hard-sell {
          font-size: 0.85rem;
          opacity: 0.9;
          color: #000000ff;
        }

        @media (max-width: 900px) {
          .book-demo-content { flex-direction: column; }
          .book-demo-text { padding: 1rem; }
          .book-demo-highlights { padding: 1rem; text-align: center; }
        }
        @media (max-width: 520px) {
          .book-demo-section { padding: 1rem 0.75rem; }
          .demo-heading { font-size: 1.35rem; }
          .demo-subheading { font-size: 0.95rem; }
          .benefit-item { font-size: 0.9rem; }
          .highlight-title { font-size: 1rem; }
          .highlight-list li { font-size: 0.9rem; }
        }
      `}</style>
    </section>
  );
};

export default BookDemoCard;
